export class WebchargeSettingDto {
    public hasSpecificChargingDays:boolean = false;
    public chargingDays:Array<string> | undefined = undefined;
}